module.exports = __webpack_public_path__ + "components/signup/static/app-mockup-7a296ae4f90a711bf0efda7feb51894e.png";